import {
  SendEmailMutation,
  SendEmailMutationVariables
} from '~email/types/__generated/gql/graphql'
import { emails } from 'ui-components'
import { graphierQL } from 'utils'
import { renderEmail } from '~email/functions/renderEmail'
const { MapGuestInvitation } = emails

export const sendMapInvitation = async ({
  receivers,
  inviteUrl,
  map,
  user
}) => {
  const subject = `Action required: ${user?.firstName} ${user?.lastName} invited you to view their map on Mapstack`

  const content = renderEmail(
    <MapGuestInvitation
      map={map}
      user={user}
      inviteLink={inviteUrl}
    />
  )

  const data = await graphierQL<SendEmailMutation, SendEmailMutationVariables>({
    query: SEND_EMAIL_MUTATION,
    variables: {
      input: {
        to: receivers,
        subject,
        content
      }
    }
  })

  return data.sendEmail
}

const SEND_EMAIL_MUTATION = /* GraphQL */ `
  mutation SendEmail($input: SendEmailInput!) {
    sendEmail(input: $input)
  }
`
